
import Router from 'vue-router'
import Vue from 'vue'
Vue.use(Router)


import login from "../views/login"
import home from "../views/home"
import team from "../views/team"
import income from "../views/income"


import withdraw from "../views/withdraw"
import playlet from '../views/playlet';
import download from '../views/playlet/down.vue';

const routes = [
    {
        path: '/',
        name: 'login',
        component: login,
    },
    {
        path: "/home",
        name: 'home',
        component: home,
        children: [
            {
                path: "/",//默认子路由
                name: 'income',
                component: income
            },
            {
                path: "/team",//团队
                name: 'team',
                component: team
            },
            {
                path: '/charge',
                name: 'charge',
                component: () => import('../views/charge/index.vue')
            }
        ]
    },

    {
        path: "/withdraw",
        name: "withdraw",
        component: withdraw
    },
    {
        path: '/bindzfb',
        name: 'bindzfb',
        component: () => import('../views/withdraw/edit.vue')
    },
    {
        path: '/invite',
        name: 'invite',
        component: () => import('../views/invite/invite.vue')
    },
    {
        path: "/playlet",
        name: "playlet",
        meta: { title: '易元剪辑' },
        component: playlet
    },
    {
        path: "/playlet/download",
        name: "playletDownload",
        meta: { title: '易元剪辑' },
        component: download
    },
    {
        path:"/upagent",
        name:"upagent",
        component:()=>import('../views/upagent/upagent.vue')
    },
    {
        path:"/activity/luckyWheel",
        name:"luckyWheel",
        meta: { title: '幸运转盘' },
        component:()=>import('../views/activity/luckyWheel/index.vue')
    },
    {
        path:"/activity/rank",
        name:"rank",
        meta: { title: '排行榜' },
        component:()=>import('../views/activity/rank/index.vue')
    },
    {
        path: '/activity/a3',
        name: 'a3',
        meta: { title: '易元剪辑' },
        component:()=>import('../views/activity/a3/index.vue')
    },
]

const createRouter = () => new Router({
    routes // (缩写) 相当于 routes: routes
})
const router = createRouter()

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
        window.document.title = to.meta.title
    }else{
        window.document.title = "代理商"
    }
    if (to && to.name === "withdraw") {
        let token = localStorage.getItem("token");
        if (token) {
            next()
        } else {
            router.push({
                name: "login"
            })
        }
    } else {
        next()
    }

})

export default router